export async function fetchLoyaltyOffers() {
  const useMockData = true;

  if (useMockData) {
    // 1️⃣ Your full list of offers lives here
    const offers = [
      {
        id: "sothebys-international-realty-russia",
        name: "Sharp Sotheby's International Realty",
        subtitle:
          "🎁 Бесплатная консультация и эксклюзивный доступ к off-market объектам.",
        description:
          "Sharp Sotheby's International Realty — лидер в сфере элитной недвижимости. 🌍 Полная конфиденциальность и защита от санкционных рисков.",
        offerOne:
          "🎁 Бесплатная консультация от эксперта Sharp Sotheby's International Realty",
        offerTwo: "🌍 Доступ к эксклюзивным off-market объектам в 100+ странах",
        offerThree:
          "🏙️ Подбор инвестиционных портфелей недвижимости с высокой доходностью",
        offerFour: "🔐 Юридическая проверка сделок (due diligence) за 3–5 дней",
        offerFive:
          "🤝 Cross-border сопровождение и интеграция локальных и международных активов",
        specialBackground: "#FFF4B7",
        isPremiumPartner: true,
        imageFileName: "sothebys_russia_logo.jpeg",
        code: "CHIC25",
        redirectUrl: "https://sothebys-realty.ru/",
        location: ["Worldwide", "Russia", "United Kingdom"],
        category: ["Real Estate", "Investment", "Luxury", "Services"],
        websiteLink: "https://sothebys-realty.ru/",
        vendorContact: "+79261191592",
        email: "tmalienko@sharp-sothebys-realty.com",
        contactName: "Татьяна Малиенко",
        discountTerms:
          "🎁 Бесплатная консультация и эксклюзивный доступ к off-market объектам Sotheby's International Realty.",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "shy-aviation",
        name: "SHY Aviation",
        subtitle: "10% скидка для участников Chic",
        description:
          "Private jet and helicopter charter service — эксклюзивные перелёты для клиентов Chic. Высокий уровень сервиса, гибкие маршруты и индивидуальный подход. ❗ Для получения скидки клиенту необходимо указать код CHIC10.",
        offerOne: "🛩️ 10% скидка от маржи, но не менее £500",
        offerTwo:
          "🚁 Индивидуальные перелёты на частных самолётах и вертолётах",
        imageFileName: "shy-aviation.jpeg",
        code: "CHIC10",
        redirectUrl: "https://t.ly/shy-aviation",
        location: ["Worldwide", "United Kingdom"],
        category: ["Transport", "Travel", "Concierge"],
        websiteLink: "https://www.shyaviation.com",
        vendorContact: "+447383784182",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "umi-esim-global",
        name: "Umi — умная eSIM",
        subtitle: "Скидка до 20% с промокодом CHIC20",
        description:
          "Umi — это умная eSIM, которая подключает вас к интернету в более чем 200 странах без роуминга и без необходимости покупать местную SIM‑карту. Просто скачайте приложение, выберите страну и активируйте eSIM — всё занимает пару минут. Подходит для путешественников, цифровых кочевников и всех, кто часто бывает за границей.",
        offerOne: "📲 Установка eSIM за пару минут",
        offerTwo: "🌍 Без роуминга и неожиданных счетов",
        offerThree: "📅 Гибкие планы от 30 до 180 дней",
        imageFileName: "Umi_App_Icon.png",
        code: "CHIC20",
        redirectUrl: "https://t.ly/umi-sim",
        location: ["Worldwide"],
        category: ["Travel", "Tech", "Services"],
        websiteLink: "https://www.reachumi.com",
        vendorContact_direct:
          "Ksenia Shuvakina: +447450351102 / Nikita: +447766076389",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "banya-london-wellness",
        name: "The Bath House",
        subtitle: "Скидка 40%",
        description:
          "The Bath House — скидка 40% на сессию (за вход) для участников сообщества. Дополнительные условия уточняйте при заказе. Количество мест ограниченно. Для бронирования перейдите по ссылке.",
        imageFileName: "BANYA_LONDON_LOGO_balck (6).png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/igor-banya",
        location: ["United Kingdom"],
        category: ["Wellness", "Beauty"],
        websiteLink: "https://banyalondon.co.uk/",
        vendorContact: "+442039062060",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "perfectlive-concierge",
        name: "Perfect Live - 2 недели бесплатно",
        subtitle: "Скидка 10%",
        description:
          "Perfect.live — ваш онлайн-ассистент для упрощения каждого аспекта жизни. Мы поможем: Спланировать путешествие от А до Я, Забронировать отель, авиабилеты и трансфер, Арендовать любой транспорт, Организовать досуг и развлечения, Заказать столик в лучших ресторанах, Подобрать идеальный подарок. Как начать? Зарегистрируйтесь с помощью телефона и почты, Заполните профиль, Выберите интересующие категории, Создайте свой первый запрос! Специальное предложение! Две недели бесплатного доступа к персональному консьерж-сервису по коду CHICPROMO! В подарок — три бесплатных запроса и дополнительная скидка на подписку!",
        offerOne: "🎁 2 недели бесплатного доступа",
        offerTwo: "🆓 3 бесплатных запроса",
        offerThree: "🤝 10% скидка на мембершип",
        imageFileName: "PerfectLive_concierge.JPG",
        code: "CHIC25",
        redirectUrl: "https://app.perfect.live/?referralCode=CHICPROMO",
        location: ["Worldwide", "United Kingdom"],
        category: ["Concierge", "Services", "Travel"],
        websiteLink: "https://perfect.live",
        vendorContact: "+447537157527",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "albion-education-consulting",
        name: "ALBION",
        subtitle: "Бесплатная консультация + скидка 10%",
        description:
          "ALBION — британская компания с более чем 20-летним профессиональным опытом управляющей команды. Стратегическое образовательное консультирование и сопровождение поступления в ведущие частные школы и университеты Великобритании, ЕС и США. Академическая диагностика, индивидуальное и групповое обучение, подготовка к тестам, экзаменам и интервью.",
        offerOne:
          "🏫 Поступление в частные школы Великобритании и ЕС, университеты и магистратуру Великобритании, США и ЕС, а также в ведущие бизнес-школы",
        offerTwo: "📚 Индивидуальное обучение по широкому спектру предметов",
        offerThree: "🧑‍🏠 Опекунство",
        offerFour:
          "🎁 Бесплатная персональная консультация с разбором кейса для участников Chic",
        offerFive: "✨ Бонусы за совместную подачу",
        imageFileName: "albion_logo.jpeg",
        code: "CHIC10",
        redirectUrl: "https://t.ly/albion-education-consulting",
        location: ["Worldwide"],
        category: ["Education", "Services"],
        websiteLink: "https://www.albion-consult.com",
        vendorContact: "+441865236391",
        whatsappNumber: "+447543827989",
        email: "contact@albionconsult.co.uk",
        contactName: "Владимир Иванов-Крымский",
        discountTerms: "10% клиенту + 10% программе",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "fine-scents-march8",
        name: "Fine Scents",
        subtitle: "Скидка 20% по промокоду GLOBALCHIC20",
        description:
          "Подарки, которые очаруют самых искушённых: духи и свечи Fine Scents — знак внимания, который не забывается. Изысканные ароматы ручной работы для тех, кто ценит утончённость и особый подход к каждому моменту. В коллекции: авторские парфюмы и ароматические свечи премиум-класса. Быстрая доставка по Великобритании и Европе",
        offerOne: "🫧 Авторские парфюмы",
        offerTwo: "🕯️ Ароматические свечи премиум-класса",
        offerThree:
          "🚚 Быстрая доставка по Великобритании и Европе — успеете к празднику",
        imageFileName: "finescents.jpg",
        code: "GLOBALCHIC20",
        redirectUrl: "https://www.finescents.co.uk",
        location: ["United Kingdom", "Europe"],
        category: ["Beauty", "Gifts", "Wellness"],
        websiteLink: "https://www.finescents.co.uk",
        vendorContact: "+447956468151",
        contactName: "Клавдия",
        discountTerms:
          "Промокод GLOBALCHIC20 на сайте 👉 www.finescents.co.uk. Партнёрство: Клавдия +44 (0)7956 468151",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "trustsearch-talent-consulting",
        name: "Trust Search — Executive Search Company",
        subtitle: "Скидка 10%",
        description:
          "Trust Search — семейная бутик-компания по поиску талантов. Надежный консультант для банков, корпораций, семейных офисов и частных клиентов в Великобритании, Швейцарии, Монако, ЦВЕ, а также на Ближнем Востоке и в Африке. Консультируем по привлечению и удержанию человеческого капитала.",
        offerOne:
          "💼 10% скидка на услуги по подбору и удержанию ключевых специалистов",
        imageFileName: "trustsearch.jpeg",
        code: "CHIC25",
        redirectUrl:
          "https://wa.me/447500900060?text=Здравствуйте%2C%20я%20участник%20Chic%2C%20хочу%20узнать%20подробнее%20об%20услугах%20с%20эксклюзивной%20скидкой%20для%20членов%20сообщества.",
        location: ["All", "United Kingdom", "Worldwide"],
        category: ["Services", "Executive Recruitment", "Consulting"],
        websiteLink: "https://www.trustsearch.london",
        vendorContact: "+447500900060",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "chateau-leperon-bordeaux",
        name: "Château L'Eperon",
        subtitle: "Скидки до 10%",
        description:
          "Винно-туристический проект в регионе Бордо, всего в 20 минутах от Сант-Эмильона. Две 5 ⭐️ виллы (на 6 или 10 человек) среди виноградников, дегустации авторских вин, пикники, прогулки на лошадях, частные и корпоративные мероприятия.",
        offerOne: "🍇 Скидка 10% на визит и дегустации",
        offerTwo:
          "🍷 Скидка 10% на заказ вина (доставка оплачивается отдельно)",
        offerThree: "🏡 Скидка 5% на аренду 5 ⭐️ вилл",
        imageFileName: "chateau_leperon.jpeg",
        code: "CHIC25",
        redirectUrl:
          "https://wa.me/33607602184?text=Здравствуйте%2C%20я%20участник%20Chic%2C%20хочу%20воспользоваться%20предложением%2C%20доступным%20для%20членов%20сообщества.",
        location: ["France"],
        category: ["Travel", "Entertainment", "Services"],
        websiteLink: "https://www.chateau-leperon.com",
        vendorContact: "+33607602184",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "zima-restaurant-nottinghill",
        name: "ZIMA Restaurant",
        subtitle: "Скидка 10%",
        description: "Эксклюзивная скидка для участников сообщества Chic.",
        offerOne: "🍽️ 10% скидка на ужин в ресторане ZIMA в Ноттинг-Хилле",
        offerTwo:
          "📍 Уточните детали при бронировании — только для участников Chic",
        imageFileName: "zima_restaurant.jpg",
        code: "CHIC25",
        redirectUrl: "https://sevn.ly/xoyg3n4E",
        location: ["United Kingdom"],
        category: ["Restaurants", "Entertainment"],
        websiteLink: "https://zima.restaurant/zimanotting",
        vendorContact: "+442045388866",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "zima-restaurant-soho",
        name: "ZIMA Restaurant — Soho",
        subtitle: "Скидка 10%",
        description: "Эксклюзивная скидка для участников сообщества Chic.",
        offerOne: "🍽️ 10% скидка на ужин в ресторане ZIMA в Сохо",
        offerTwo:
          "📍 Уточните детали при бронировании — только для участников Chic",
        imageFileName: "zima_restaurant.jpg",
        code: "CHIC25",
        redirectUrl: "https://sevn.ly/x76jkmXX",
        location: ["United Kingdom"],
        category: ["Restaurants", "Entertainment"],
        websiteLink: "https://zima.restaurant/zimasoho",
        vendorContact: "+442074949111",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "zima-home-delivery",
        name: "ZIMA — Доставка на дом",
        subtitle: "Скидка 25%",
        description: "Эксклюзивная скидка для участников сообщества Chic.",
        offerOne: "🛵 25% скидка на доставку блюд ZIMA на дом с кодом CHIC25",
        offerTwo:
          "🛒 Заказ через онлайн-платформу ZIMA — только для участников Chic",
        imageFileName: "zima_restaurant.jpg",
        code: "CHIC25",
        redirectUrl: "https://zimasw.slerp.com/order",
        location: ["United Kingdom"],
        category: ["Restaurants", "Delivery", "Food and Beverages"],
        websiteLink: "https://zimasw.slerp.com/order",
        vendorContact: "+442074949111",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "attilus-caviar-london",
        name: "Attilus Caviar — Скидка на Royal Oscietra",
        subtitle: "Скидка 10% по коду CHIC26",
        description:
          "Attilus Caviar – осетровая икра для гурманов от одного из ведущих европейских брэндов. Возможность доставки в тот же день по центру Лондона. Эксклюзивная скидка на Royal Oscietra Caviar для членов сообщества с кодом CHIC26.",
        imageFileName: "attilus_logo.png",
        code: "CHIC26",
        redirectUrl:
          "https://www.attiluscaviar.co.uk/discount/CHIC2025?redirect=%2Fproducts%2Froyal-oscietra-caviar",
        location: ["United Kingdom"],
        category: ["Delivery", "Food and Beverages"],
        websiteLink: "https://www.attiluscaviar.co.uk",
        vendorContact: "+442077238009",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "pinna-dining",
        name: "Ресторан Pinna",
        subtitle: "Скидка 10 фунтов/бронирование",
        description: "Подарок для участников Chic Loyalty.",
        offerOne: "🍽️ Обед и ужин с понедельника по субботу",
        offerTwo: "🥂 Игристое по прибытии",
        imageFileName: "PINNA LOGO BLACK.png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/pinna_phone_reservation",
        location: ["United Kingdom"],
        category: ["Restaurants", "Entertainment"],
        websiteLink: "https://www.pinnamayfair.com/",
        vendorContact: "+447584574732",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "krokodilos-dining",
        name: "Ресторан Krokodilos",
        subtitle: "Скидка 10%",
        description: "Специальное предложение для участников Chic Loyalty.",
        offerOne: "🍽️ Обед с понедельника по пятницу: 10% скидка",
        offerTwo:
          "🥂 Понедельник – четверг с 17:00 до 19:00: игристое по прибытии",
        imageFileName: "KROKODILOS.png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/krokodilos_phone_reservation",
        location: ["United Kingdom"],
        category: ["Restaurants", "Entertainment"],
        websiteLink: "https://www.krokodilos.co.uk/",
        vendorContact: "+447584574732",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "wild-nottinghill",
        name: "Ресторан Wild — Notting Hill",
        subtitle: "Скидка 10%",
        description: "Эксклюзивная скидка для участников Chic Loyalty.",
        offerOne: "🍽️ Обед с понедельника по пятницу: 10% скидка",
        imageFileName: "WILD_NH.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/wildNH_phone_reservation",
        location: ["United Kingdom"],
        category: ["Restaurants", "Entertainment"],
        websiteLink: "https://www.wildnottinghill.com/",
        vendorContact: "+447584574732",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "belvedere-events",
        name: "Ресторан Belvedere",
        subtitle: "Скидка 10%",
        description:
          "Мероприятия — 10% скидка при полной аренде пространства или аренде верхнего этажа",
        imageFileName: "Belvedere logo.png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/belvedere_phone_reservation",
        location: ["United Kingdom"],
        category: ["Restaurants", "Entertainment", "Events"],
        websiteLink: "https://www.belvedererestaurant.co.uk/",
        vendorContact: "+447584574732",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "azbuka-school",
        name: "AZBUKA School",
        subtitle: "Скидка 10%",
        description:
          "Скидка на первый год обучения в общеобразовательной билингвальной школе AZBUKA с русско-английской программой обучения — эксклюзивно для участников Chic.",
        offerOne: "🎓 10 % скидка на первый учебный год по коду CHIC25",
        imageFileName: "azbuka_school.jpg",
        code: "CHIC25",
        redirectUrl: "mailto:admin@azbukafoundation.org",
        location: ["United Kingdom"],
        category: ["Education"],
        websiteLink: "https://www.azbukafoundation.org/?utm_source=chic",
        vendorContact: "+442083922286",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "keepbeauty-wellness-bundle",
        name: "Салон Keep Beauty",
        subtitle: "Скидки до 15%",
        description:
          "Участникам Chic Loyalty доступны эксклюзивные скидки в уютной атмосфере Keep Beauty:",
        offerOne: "💅 10% на маникюр",
        offerTwo: "💇‍♀️ 15% на уход за волосами",
        imageFileName: "keep_beauty_logo.JPG",
        code: "CHIC25",
        redirectUrl: "https://t.ly/keep-beauty",
        location: ["United Kingdom"],
        category: ["Wellness", "Beauty"],
        websiteLink: "https://keepbeauty.co.uk/",
        vendorContact: "+447411347960",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "zima-style-wellness-bundle",
        name: "Салон ZIMA Style",
        subtitle: "Скидки до 20%",
        description:
          "Участникам Chic Loyalty доступны специальные условия в салоне ZIMA STYLE в Holland Park:",
        offerOne: "💇‍♀️ 10% на укладки — вечерние, свадебные и повседневные",
        offerTwo: "💆‍♀️ 20% на уходы, включая «Счастье для волос»",
        offerThree: "👁️ 10% на брови и ресницы — коррекция и окрашивание",
        offerFour:
          "🧖‍♀️ Парики: прокат от £400 в день со скидкой 10%, продажа со средней ценой £3500 и скидкой 5%",
        imageFileName: "zima_style.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/zimastyle-salon",
        location: ["United Kingdom"],
        category: ["Wellness", "Beauty", "Services"],
        websiteLink: "https://sergiizyma.co.uk/",
        vendorContact: "+447881238229",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "albatross-healthcare",
        name: "Albatross Healthcare — Personal Insurance Concierge",
        description:
          "Albatross Healthcare — независимый эксперт по международному медицинскому страхованию и страхования жизни. Участникам Chic Loyalty доступны:",
        offerOne:
          "🤝 ⁠Полное ведение страховых случаев с безлимитным количеством обращений",
        offerTwo:
          "📞 Прямой контакт только с руководителем компании (без посредников и junior staff)",
        offerThree: "🔁 Аудит текущих полисов под ваши нужды",
        offerFour: "👨‍💼 Контакты лучших врачей по всему миру",
        offerFive: "‼️ Специальным ценовые предложения",
        imageFileName: "alba_white.JPG",
        code: "CHIC25",
        redirectUrl: "https://t.ly/alba",
        location: ["Worldwide", "United Kingdom"],
        category: ["Health", "Insurance", "Services"],
        websiteLink: "https://albatrosshealthcare.co.uk/",
        vendorContact: "+442045772274",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "aqlo-accounting",
        name: "AQLO Accounting & Law",
        subtitle: "Скидки до 50%",
        description:
          "Профессиональные бухгалтерские и налоговые услуги для компаний и частных клиентов: от комплексного сопровождения бизнеса до индивидуальных консультаций и налоговой оптимизации.",
        offerOne: "📊 50% скидка на налоговую консультацию",
        offerTwo:
          "💼 10% скидка на услуги после консультации (SA, годовая отчетность, корпоративный налог, бухгалтерия)",
        imageFileName: "aqlo_logo.jpeg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/aqlo-accounting",
        location: ["Worldwide", "United Kingdom"],
        category: ["Finance", "Tax", "Services", "Legal"],
        websiteLink: "https://aqlo.co.uk/",
        vendorContact: "+447800767690",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "sterling-law",
        name: "Sterling Law",
        subtitle: "Скидка 15%",
        description:
          "Sterling Law — юридическая фирма с 15-летним опытом, входящая в рейтинг The Legal 500. Специализация: иммиграционное, корпоративное, трудовое, семейное и уголовное право. Обслуживаем частных и корпоративных клиентов. Многопрофильная русско- и украиноязычная юридическая поддержка в центре Лондона.",
        offerOne: "⚖️ 15% скидка для участников Chic Loyalty",
        imageFileName: "sterling_law_logo.jpeg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/sterling-law",
        location: ["Worldwide", "United Kingdom"],
        category: ["Legal", "Immigration", "Services"],
        websiteLink: "https://sterling-law.co.uk/",
        vendorContact: "+447935884144",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "ibsvp-services",
        name: "IBSVP Concierge & Services",
        subtitle: "Скидка 10%",
        description:
          "Российские документы, переводы, нотариальное сопровождение и премиальный туристический сервис в Лондоне.",
        offerOne: "🛂 Загранпаспорт РФ + запись: £200 — 10 %",
        offerTwo: "📑 Доверенность в посольстве РФ: £200 — 10 %",
        offerThree: "📝 Перевод RU→EN — 10 %",
        offerFour: "🇷🇺 Гражданство / выход — 10 %",
        imageFileName: "ibsvp_logo.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/IBSVP",
        location: ["Worldwide", "United Kingdom"],
        category: ["Services", "Legal", "Immigration", "Travel", "Concierge"],
        websiteLink: "https://ibsvp.co.uk/",
        vendorContact: "+442079851234",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "beyond-residence-citizenship",
        name: "BEYOND Residence & Citizenship",
        subtitle: "Скидка 10%",
        description:
          "Паспорт и ПМЖ в 33 странах. Неординарные решения для частных клиентов и их семей.",
        offerOne:
          "🌍 10% скидка на услуги по получению ПМЖ и гражданства в 33 странах",
        imageFileName: "beyond_logo.jpeg",
        code: "CHIC25",
        redirectUrl:
          "https://wa.me/447341512626?text=Здравствуйте%2C%20я%20участник%20Chic%2C%20хочу%20воспользоваться%20скидкой%2010%%20на%20услуги%20BEYOND.",
        location: ["Worldwide", "United Kingdom"],
        category: ["Legal", "Immigration", "Services"],
        websiteLink: "https://beyondimmigration.ru/",
        vendorContact: "+447341512626",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "solvix-uk-relocation",
        name: "Solvix UK Relocation",
        subtitle: "Скидка 10%",
        description: "Полное сопровождение переезда в Британию под ключ.",
        offerOne: "🏠 10 % скидка на пакеты релокации в GB",
        imageFileName: "solvix_logo.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/solvix-uk",
        location: ["Worldwide", "United Kingdom"],
        category: ["Services", "Immigration", "Real Estate", "Consulting"],
        websiteLink: "https://www.solvix.co.uk/",
        vendorContact: "+442079851222",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "az-real-estate",
        name: "AZ Real Estate, скидка на услуги агенства",
        subtitle: "Скидка 10%",
        description:
          "AZ Real Estate — агентство недвижимости с 13-летним опытом и офисом в центре Лондона. Помогаем частным клиентам купить, продать и инвестировать в недвижимость в Великобритании. Индивидуальный подход и экспертиза мирового уровня.",
        offerOne: "🏠 Бесплатная консультация",
        offerTwo: "📈 Скидка 10% на услуги AZ Real Estate",
        imageFileName: "az_real_estate_logo.png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/az-real-estate",
        location: ["Worldwide", "United Kingdom"],
        category: ["Real Estate", "Finance", "Consulting"],
        websiteLink: "https://www.azrealestate.uk/",
        vendorContact: "+442038714074",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "visatogo",
        name: "VisaToGo",
        subtitle: "Скидка 10%",
        description: "Визы в РФ, Шенген, США, Китай и др. страны.",
        offerOne: "🛂 10 % скидка на любые визы",
        imageFileName: "visatogo_logo.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/visa-to-go",
        location: ["Worldwide", "United Kingdom"],
        category: ["Travel", "Immigration", "Services"],
        websiteLink: "https://visatogo.co.uk/",
        vendorContact: "+442079851212",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "martins-travel",
        name: "Martin's Travel",
        subtitle: "Скидка 5%",
        description: "Индивидуальные путешествия «под ключ» по всему миру.",
        offerOne: "✈️ 5 % скидка на комплексные туры",
        imageFileName: "martins_travel_logo.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/martins-travel",
        location: ["Worldwide"],
        category: ["Travel", "Concierge"],
        websiteLink: "https://www.martins.travel/",
        vendorContact: "+442079851245",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "pegasus-private",
        name: "Pegasus Private Cars",
        subtitle: "Скидка 10%",
        description:
          "Pegasus Private Cars — эксклюзивный сервис аренды премиум-автомобилей с личным водителем. Мы предлагаем комфорт, конфиденциальность и персонализированные решения для самых требовательных клиентов.",
        offerOne: "👨🏼‍✈️ 10% скидка на услуги личного водителя",
        offerTwo: "🧒 Сопровождение детей в школу или аэропорт",
        offerThree:
          "🐾 Транспортировка домашних питомцев по Великобритании и за её пределами",
        offerFour: "🧳 Встречи в аэропорту и помощь с багажом",
        offerFive: "✨ Индивидуальные услуги по запросу",
        imageFileName: "pegasus_private_cars.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/pegasus-auto",
        location: ["United Kingdom"],
        category: ["Transport", "Travel", "Concierge"],
        websiteLink: "https://www.instagram.com/p/DELOirlOViw/",
        vendorContact: "+447728325988",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "soulmatcher-app-comingsoon",
        name: "SoulMatcher",
        subtitle: "Месяц бесплатной подписки",
        description:
          "SoulMatcher — премиальное приложение для серьёзных знакомств, созданное для профессионалов и предпринимателей, которые ценят психологическую совместимость и не хотят отношений с высоким риcком разрыва. Доступ получают только участники, прошедшие предварительный отбор. SoulMatcher — пространство, где создаются настоящие отношения.",
        offerOne:
          "🎁 Для сообщества Global Chic: используйте инвайт-код GCHIC при регистрации и получите 1 месяц бесплатной подписки",
        offerTwo:
          "📩 Всем участникам коммьюнити Глобал Шик регистрация доступна по приглашению через лист ожидания",
        imageFileName: "SoulMatcher Logo (1).ai.jpg",
        redirectUrl: "https://soulmatcher.app/",
        location: ["Worldwide", "United Kingdom"],
        category: ["Wellness", "Entertainment", "Services"],
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "masterpiece-group",
        name: "MASTERPIECE GROUP",
        subtitle: "Скидка 10%",
        description:
          "это команда экспертов с 14-летним опытом, которая помогает предпринимателям и инвесторам обустроить жизнь и запустить бизнес в Объединённых Арабских Эмиратах. Мы сопровождаем вас на каждом этапе: от регистрации компании и получения ВНЖ — до покупки и управления недвижимостью, а также оптимизации налоговой нагрузки.",
        offerOne:
          "💼 10% скидка на бизнес-услуги в Дубае (регистрация компаний, ВНЖ, открытие счетов)",
        offerTwo: "🏆 Бесплатная золотая виза при покупке недвижимости",
        offerThree: "🏠 10% скидка на услуги по управлению вашей недвижимостью",
        imageFileName: "masterpiece.png",
        redirectUrl: "https://t.ly/masterpiece-group",
        location: ["Worldwide", "United Arab Emirates"],
        category: ["Services", "Consulting"],
        websiteLink: "https://masterpiece.ae",
        vendorContact: "+971505578931",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "masterpiece-concierge",
        name: "MASTERPIECE CONCIERGE",
        subtitle: "Скидка 10%",
        description:
          "Премиальный консьерж-сервис в Дубае 24/7. Мы берём на себя все организационные вопросы: трансферы, бронирования, клубная жизнь, личный ассистент, шопинг-сопровождение и любые запросы, доступные 24/7.",
        offerOne: "🚗 10% скидка на транспортные услуги",
        offerTwo: "💳 10% скидка на клубную карту MASTERPIECE",
        imageFileName: "masterpiece.png",
        redirectUrl: "https://t.ly/masterpiece-concierge",
        location: ["Worldwide", "United Arab Emirates"],
        category: [
          "Concierge",
          "Services",
          "Finance",
          "Immigration",
          "Legal",
          "Real Estate",
          "Tax",
          "Transport",
          "Travel",
        ],
        websiteLink: "https://masterpiece.ae/services/concierge-services/",
        vendorContact: "+971505578931",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "mango-language-school",
        name: "Mango Language School — Языковая школа",
        subtitle: "Скидка 15%",
        description:
          "Mango Language School — школа иностранных языков для детей и взрослых с индивидуальным подходом. Подготовка к экзаменам GCSE и A-Level, языковая подготовка для поступления в школы Великобритании и обучение иностранным языкам. Мы помогаем ученикам уверенно учиться, сдавать экзамены и адаптироваться к британской образовательной системе.",

        offerOne:
          "📚 Подготовка к экзаменам GCSE и A-Level (английский и другие предметы)",

        offerTwo:
          "🎓 Языковая подготовка для поступления в школы Великобритании",

        offerThree:
          "🌍 Обучение иностранным языкам: английский, русский, французский, немецкий, китайский и другие — по запросу",

        offerFour:
          "🧑‍🏫 Формат обучения: онлайн-уроки и занятия с выездом преподавателя на дом",

        offerFive: "💸 15% скидка на обучение для участников сообщества Chic",
        imageFileName: "mango-school.jpeg",
        code: "CHIC25",
        redirectUrl:
          "https://globalchic.club/loyalty-program/mango-language-school",
        location: ["United Kingdom", "Worldwide"],
        category: ["Education", "Services"],
        websiteLink: "https://www.mangoengl.com/ru",
        vendorContact: "+44 7 4583 57899",
        email: "Tina.nevin2020@gmail.com",
        contactName: "Кристина Nevin",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "kartina-tv",
        name: "Kartina.TV",
        subtitle: "Пробная подписка без привязки карты",
        description:
          "Kartina.TV — 9 видеотек и 200+ каналов в любой точке мира.",
        offerOne:
          "🎁 Эксклюзивный бесплатный пробный период для участников Chic — без привязки банковской карты ",
        offerTwo: "📱 Удобное приложение для iOS и Android",
        offerThree: "🔄 Одновременный просмотр на трёх устройствах",
        offerFour: "🕑 Круглосуточная служба технической поддержки",
        imageFileName: "kartina.png",
        redirectUrl: "https://t.ly/kartina-tv",
        location: ["All", "United Kingdom", "Worldwide"],
        category: ["Entertainment", "Services"],
        websiteLink: "https://www.kartina.tv",
        vendorContact: "0 800 090 31 33",
        email: "i.kryvonos@kartina.tv",
        contactName: "Ivan",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "boss-ii-organic-wine-olive-oil",
        name: "BOSS II Organic Wine&Olive Oil",
        subtitle: "Скидки до 15%",
        description:
          "BOSS II — семейный бизнес по производству органического вина и оливкового масла в Тоскане. Первая винтажная коллекция 2022 года уже отмечена экспертами. Доставка до двери в Италии, Европе и Лондоне по запросу.",
        offerOne: "🍇 10% скидка для участников Chic в Италии",
        imageFileName: "SelivanovaWines.jpg",
        redirectUrl: "https://t.ly/SelivanovaWines",
        location: ["Italy", "Worldwide"],
        category: ["Food and Beverages", "Wine"],
        vendorContact: "+447795968314",
        email: "olga.selivanova@yahoo.co.uk",
        contactName: "Ольга Селиванова",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "eli-gervits-law",
        name: 'Адвокатская коллегия "Эли Гервиц"',
        subtitle: "Скидка 10%",
        description:
          "Крупнейшая в Израиле русскоязычная адвокатская коллегия. Департаменты: израильский, международный, российский, финансовый.",
        offerOne: "⚖️ Персональное сопровождение дел",
        offerTwo: "🌍 Израильское, международное и российское право",
        offerThree: "💼 Финансовый департамент и комплексные решения",
        imageFileName: "Daniel_Rapoport.jpg",
        code: "CHIC25",
        redirectUrl: "https://aliya.zakon.co.il/#contacts",
        location: ["Israel", "Worldwide"],
        category: ["Legal", "Immigration", "Finance", "Services"],
        websiteLink: "https://outrussian.zakon.co.il/",
        vendorContact: "zakon@zakon.co.il",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "marco-barberi-dentist",
        name: "Studio Dentistico Marco Barberi",
        subtitle: "Скидка 5% + бесплатная гигиеническая чистка",
        description:
          "Доктор Марко Барбери — стоматолог в центре Форте-дей-Марми (Тоскана, Италия). Практика с 1994 года (31 год опыта). Полный спектр стоматологических услуг: хирургия (импланты, костная реконструкция), эстетика (виниры, пломбы), протезирование (коронки и большие реконструкции), ортодонтия (традиционная и Invisalign), пародонтология. Философия работы — максимальное качество, доброжелательность и доступность.",
        offerOne: "🎁 5% скидка на все лечения",
        offerTwo:
          "🦷 Бесплатная гигиеническая чистка при записи через сообщество",
        imageFileName: "Marco_Barberi.jpeg",
        code: "CHIC25",
        redirectUrl: "https://www.marcobarberi.it",
        location: ["Italy"],
        category: ["Health", "Wellness", "Services"],
        websiteLink: "https://www.marcobarberi.it",
        vendorContact: "+393478151020",
        email: "blu5marco@gmail.com",
        contactName: "Dr. Marco Barberi",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "ls-legal-solicitors",
        name: "LS Legal Solicitors",
        subtitle: "Скидка 10%",
        description:
          "LS Legal Solicitors — многопрофильная юридическая фирма в Великобритании. Мы работаем с бизнесом и частными клиентами, предоставляя услуги в сфере иммиграции и гражданства, гражданских, семейных, трудовых и жилищных дел. Также оказываем поддержку при переезде в Великобританию, предоставляем коммерческие и бухгалтерские услуги, юридическое сопровождение бизнеса, легализацию и переводы. Отличаемся индивидуальным подходом и высоким уровнем сервиса.",
        offerOne:
          "⚖️ Иммиграция, гражданство и релокация в Великобританию и ОАЭ",
        offerTwo: "📑 Гражданские, семейные, трудовые и жилищные дела",
        offerThree:
          "💼 Коммерческие услуги, договорное право и бизнес-поддержка",
        offerFour: "📊 Бухгалтерские и налоговые консультации",
        offerFive: "🌍 Переводы, легализация и сертификация документов",
        imageFileName: "ls_legal.png",
        code: "CHIC25",
        redirectUrl: "https://www.lslegaluk.com/contact-us",
        location: ["United Kingdom", "Worldwide"],
        category: ["Legal", "Immigration", "Services", "Finance", "Consulting"],
        websiteLink: "https://www.lslegaluk.com/",
        vendorContact: "+447535959450",
        email: "info@lslegaluk.com",
        contactName: "Liliya Scott",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "yt-partners-yachting",
        name: "YT Partners",
        subtitle: "Дополнительные услуги клиенту",
        description:
          "YT Partners — профессионалы в сфере аренды, управления и продаж яхт. Приглашаем вас на Monaco Yacht Show, который пройдет 24–27 сентября в Порт Эркюль, Монако. Для участников Chic доступны приглашения и персональные визиты на лучшие суперъяхты.",
        offerOne:
          "🛥️ Для арендаторов: индивидуальный подбор яхт под ваши требования",
        offerTwo:
          "🔑 Эксклюзивный доступ к private listing + комплимент Dom Perignon при посадке",
        offerThree: "🤝 Консьерж-сервис 24/7 и полное сопровождение круиза",
        offerFour:
          "⚓ Для владельцев: профессиональное управление яхтами до 95 метров",
        imageFileName: "yt_partners_logo.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/yt.partners",
        location: ["Worldwide", "United Kingdom", "Monaco", "France"],
        category: ["Luxury", "Travel", "Yachting", "Concierge"],
        websiteLink: "https://yt.partners/",
        vendorContact: "+447500173119",
        email: "dl@yt.partners",
        contactName: "Даша Лялина",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "dseesion-interiors",
        name: "Dseesion Interiors",
        subtitle: "Скидка £3,000 + особые условия",
        description:
          "Интерьерное бюро Dseesion Interiors — более 20 лет создаёт и реализует под ключ премиальные проекты жилой и коммерческой недвижимости по всему миру. Победители международных конкурсов в сфере дизайна. Креативная команда с большим практическим опытом, умением доводить проекты до конца в срок и в рамках бюджета.",
        offerOne: "🎁 £3,000 скидка при заключении договора на дизайн-проект",
        offerTwo:
          "🛋️ Особые условия на закупки мебели и предметов декора при реализации проекта",
        imageFileName: "dseesion_logo.png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/dseesion-interiors",
        location: ["Worldwide", "United Kingdom"],
        category: [
          "Design",
          "Architecture",
          "Luxury",
          "Services",
          "Real Estate",
        ],
        websiteLink: "https://dseesion.com",
        vendorContact: "+447506863221",
        email: "valeria.senkina@dseesion.com",
        contactName: "Сенькина Валерия",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "your-place-with-grace",
        name: "Your Place with Grace",
        subtitle: "Скидка до 15%",
        description:
          "Your Place with Grace — премиальные проекты под ключ: от ремонта и мебели на заказ до обслуживания недвижимости. Качество, сроки и комфорт без компромиссов.",
        offerOne: "🏗️ Строительство и ремонт — скидка до 10% на работы",
        offerTwo: "🛋️ Мебель на заказ — скидка 10–15%",
        offerThree: "⚡ Блиц-ремонты во время отпуска",
        offerFour: "🧰 Обслуживание недвижимости и сопровождение строительства",
        imageFileName: "your-place-with-grace.png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/your-place-with-grace",
        location: ["United Kingdom"],
        category: ["Services", "Construction", "Real Estate", "Design"],
        websiteLink: "https://www.instagram.com/your.place.with.grace/",
        vendorContact: "+447985957305",
        email: "irina@yourplacewithgrace.co.uk",
        contactName: "Irina Filatova",
        discountTerms:
          "Строительство и ремонт — скидка до 10% на работы; мебель — 10–15%.",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "lawsentis-immigration",
        name: "LawSentis LTD",
        subtitle: "Скидки до 20%",
        description:
          "LawSentis LTD — иммиграционные адвокаты (IAA Level 3). Помогаем с визами, гражданством, апелляциями, бизнес- и семейными кейсами, а также с релокацией и смежными вопросами.",
        offerOne:
          "✅ Pre-Settled, Settled, ILR, Натурализация и British Citizenship",
        offerTwo:
          "⚖️ Беженство, права человека и апелляции (lodging, skeleton, слушания)",
        offerThree:
          "🌍 Global Talent и бизнес-визы (Innovator Founder), подготовка бизнес-планов",
        offerFour: "👨‍👩‍👧 Семейные визы: жених/невеста, супруги, родители",
        offerFive:
          "🇪🇸 Релокация в Испанию и Португалию; 📊 бухгалтерия: годовые отчёты и возврат налогов",
        imageFileName: "law-sentis.jpeg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/law-sentis",
        location: ["United Kingdom", "Spain", "Portugal", "Worldwide"],
        category: ["Legal", "Immigration", "Business", "Services"],
        websiteLink: "https://lawsentis.com/",
        vendorContact: "+447733648414",
        contactName: "LawSentis Team",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "showroom-studio-design-exclusiv",
        name: "SHOWROOM — Studio Design Exclusiv",
        subtitle: "Специальные условия для участников Chic",
        description:
          "Реализация интерьерных проектов - разработка дизайна, подбор и комплектация, авторский надзор. Дизайн-проекты собственной командой и мировыми дизайнерами, подбор и комплектация отделочных материалов, освещения, мебели, кухонь, гардеробных и текстиля. Партнёрство с ведущими итальянскими и международными брендами (Poliform, Minotti, Flexform, Antonio Lupi, Flos, Hermes Home и др.).",
        offerOne: "🎁 Специальные условия при комплексной реализации проектов",
        offerTwo:
          "🛋️ Специальные цены на продукцию премиальных брендов для дома",
        offerThree:
          "✨ Мебель, освещение, текстиль от ведущих мировых производителей",
        imageFileName: "studio_design_exclusiv1.jpeg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/studio-design-exclusiv",
        location: ["United Kingdom", "Worldwide"],
        category: ["Design", "Interiors", "Luxury", "Services"],
        websiteLink: "www.studiodesign.md",
        vendorContact: "+373 79 585 777",
        email: "office@studiodesign.md",
        contactName: "Alex Naval",
        discountTerms:
          "Специальные условия при реализации проектов + специальные цены на продукцию брендов",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "uk-study-centre",
        name: "UK Study Centre",
        subtitle: "Скидка 10%",
        description:
          "UK Study Centre — ваш консультант по британскому образованию с 20-летним опытом. Топовые британские тьюторы по всем предметам. Бесплатные консультации по летним и языковым школам для участников сообщества. Скидка 10% на пакеты по поступлению в школы и университеты Великобритании и других стран.",
        offerOne: "🎁 Бесплатные консультации по летним и языковым школам",
        offerTwo:
          "🎓 10% скидка на пакеты по поступлению в школы и университеты",
        offerThree: "📚 Поддержка лучших британских тьюторов по всем предметам",
        imageFileName: "uk_study_centre_logo.png",
        code: "CHIC25",
        redirectUrl: "https://t.ly/uk-study-centre",
        location: ["United Kingdom", "Worldwide"],
        category: ["Education", "Services"],
        websiteLink: "https://www.ukstudycentre.com/",
        vendorContact: "+447970293673",
        email: "alex@ukstudycentre.com",
        contactName: "Alex Nanian",
        discountTerms:
          "10% клиенту + 10% программе на пакеты по поступлению в школы/университеты",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "vdl-constructions-dubai",
        name: "VDL Constructions — Строительство и дизайн в Дубае",
        subtitle: "Специальные условия для участников Chic",
        description:
          "🏗️ VDL Constructions — дизайнерские решения, строительство и реновация премиум-класса в Дубае. Команда архитекторов, инженеров и строителей предлагает эксклюзивные проекты под ключ с использованием премиальных материалов и инновационных технологий. При заключении договора на строительство/реновацию:",
        offerOne: "📐 Эскизный проект — бесплатно",
        offerTwo: "📄 5% скидка на проектную документацию",
        offerThree:
          "👷‍♂️ Авторский надзор бесплатно при площади проекта от 600 м²",
        imageFileName: "vdl_constructions.jpeg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/VDL_construction",
        location: ["UAE", "Dubai"],
        category: [
          "Construction",
          "Design",
          "Luxury",
          "Real Estate",
          "Services",
        ],
        websiteLink: "https://vdlconstructions.com",
        vendorContact: "+971508240177",
        vendorContactAdditional: "+971547822211",
        email: "info@vdlconstructions.com",
        contactName: "VDL Constructions Team",
        discountTerms:
          "Эскизный проект бесплатно, скидка 5% на проектную документацию, авторский надзор бесплатно при проекте от 600 м².",
        whatsapp: {
          enabled: true,
          groupIds: [],
          maxGroupsPerRun: 3,
          language: "ru",
        },
      },
      {
        id: "shatro-construction",
        name: "SHATRO",
        subtitle: "Скидка 10%",
        description:
          "SHATRO — строительная компания, создающая современные жилые объекты, коммерческие пространства и офисы под ключ. Мы обеспечиваем архитектурную точность, выверенные решения и безупречное качество исполнения. Проектирование, строительство, авторский дизайн, подбор материалов, мебели и декора — полный цикл под одной командой",
        offerOne:
          "🏗️ Комплексные строительные и инвестиционные проекты под ключ",
        offerTwo: "🎨 Дизайн и подбор отделочных материалов, мебели и декора",
        offerThree: "🏡 Реализация жилых и коммерческих объектов",
        imageFileName: "shatro_logo.jpg",
        code: "CHIC25",
        redirectUrl: "https://t.ly/shatro-construction",
        location: ["Cyprus", "Worldwide", "United Kingdom"],
        category: ["Construction", "Design", "Real Estate", "Services"],
        websiteLink: "https://shatro.com/",
        vendorContact: "+35795999595",
        email: "assistant@shatro.com",
        contactName: "Лариса",
        discountTerms:
          "10% клиенту + 10% программе при заключении договора на услуги.",
      },
    ];

    // 2️⃣ Общий дефолтный WhatsApp-конфиг для всех вендоров
    const defaultWhatsappConfig = {
      enabled: true, // по умолчанию участвует в рассылках
      groupIds: [
        "1203630XXXXX@g.us", // TODO: заменить на реальные ID групп
        "1203630YYYYY@g.us",
      ],
      maxGroupsPerRun: 3, // максимум 2–3 группы за один запуск
      language: "ru", // базовый язык сообщений
    };

    // 3️⃣ Добавляем whatsapp к каждому офферу
    const offersWithWhatsapp = offers.map((offer) => ({
      ...offer,
      whatsapp: {
        ...defaultWhatsappConfig,
        ...(offer.whatsapp || {}), // если у конкретного оффера задан свой whatsapp — он перезапишет дефолт
      },
    }));

    return Promise.resolve(offersWithWhatsapp);
  }

  // 4️⃣ Реальный API-фетч, когда отключишь mock
  const response = await fetch("/api/loyalty/offers");
  if (!response.ok) throw new Error("API error");
  return await response.json();
}

// export async function fetchLoyaltyOffers() {
//   const useMockData = true;

//   if (useMockData) {
//     return Promise.resolve([
//       {
//         id: "sothebys-international-realty-russia",
//         name: "Sharp Sotheby’s International Realty",
//         subtitle:
//           "🎁 Бесплатная консультация и эксклюзивный доступ к off-market объектам.",
//         description:
//           "Sharp Sotheby’s International Realty — лидер в сфере элитной недвижимости. 🌍 Полная конфиденциальность и защита от санкционных рисков.",
//         offerOne:
//           "🎁 Бесплатная консультация от эксперта Sharp Sotheby’s International Realty",
//         offerTwo: "🌍 Доступ к эксклюзивным off-market объектам в 100+ странах",
//         offerThree:
//           "🏙️ Подбор инвестиционных портфелей недвижимости с высокой доходностью",
//         offerFour: "🔐 Юридическая проверка сделок (due diligence) за 3–5 дней",
//         offerFive:
//           "🤝 Cross-border сопровождение и интеграция локальных и международных активов",
//         specialBackground: "#FFF4B7",
//         isPremiumPartner: true,
//         imageFileName: "sothebys_russia_logo.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://sothebys-realty.ru/",
//         location: ["Worldwide", "Russia", "United Kingdom"],
//         category: ["Real Estate", "Investment", "Luxury", "Services"],
//         websiteLink: "https://sothebys-realty.ru/",
//         vendorContact: "+79261191592",
//         email: "tmalienko@sharp-sothebys-realty.com",
//         contactName: "Татьяна Малиенко",
//         discountTerms:
//           "🎁 Бесплатная консультация и эксклюзивный доступ к off-market объектам Sotheby’s International Realty.",
//       },
//       {
//         id: "shy-aviation",
//         name: "SHY Aviation",
//         subtitle: "10% скидка для участников Chic",
//         description:
//           "Private jet and helicopter charter service — эксклюзивные перелёты для клиентов Chic. Высокий уровень сервиса, гибкие маршруты и индивидуальный подход. ❗ Для получения скидки клиенту необходимо указать код CHIC10.",
//         offerOne: "🛩️ 10% скидка от маржи, но не менее £500",
//         offerTwo:
//           "🚁 Индивидуальные перелёты на частных самолётах и вертолётах",
//         imageFileName: "shy-aviation.jpeg",
//         code: "CHIC10",
//         redirectUrl: "https://t.ly/shy-aviation",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Transport", "Travel", "Concierge"],
//         websiteLink: "https://www.shyaviation.com",
//         vendorContact: "+447383784182",
//       },
//       {
//         id: "umi-esim-global",
//         name: "Umi — умная eSIM",
//         subtitle: "Скидка до 20% с промокодом CHIC20",
//         description:
//           "Umi — это умная eSIM, которая подключает вас к интернету в более чем 200 странах без роуминга и без необходимости покупать местную SIM‑карту. Просто скачайте приложение, выберите страну и активируйте eSIM — всё занимает пару минут. Подходит для путешественников, цифровых кочевников и всех, кто часто бывает за границей.",
//         offerOne: "📲 Установка eSIM за пару минут",
//         offerTwo: "🌍 Без роуминга и неожиданных счетов",
//         offerThree: "📅 Гибкие планы от 30 до 180 дней",
//         imageFileName: "Umi_App_Icon.png",
//         code: "CHIC20",
//         redirectUrl: "https://t.ly/umi-sim",
//         location: ["Worldwide"],
//         category: ["Travel", "Tech", "Services"],
//         websiteLink: "https://www.reachumi.com",
//         vendorContact_direct:
//           "Ksenia Shuvakina: +447450351102 / Nikita: +447766076389",
//       },

//       {
//         id: "banya-london-wellness",
//         name: "The Bath House",
//         subtitle: "Скидка 40%",
//         description:
//           "The Bath House — скидка 40% на сессию (за вход) для участников сообщества. Дополнительные условия уточняйте при заказе. Количество мест ограниченно. Для бронирования перейдите по ссылке.",
//         imageFileName: "BANYA_LONDON_LOGO_balck (6).png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/igor-banya",
//         location: ["United Kingdom"],
//         category: ["Wellness", "Beauty"],
//         websiteLink: "https://banyalondon.co.uk/",
//         vendorContact: "+442039062060",
//       },
//       {
//         id: "perfectlive-concierge",
//         name: "Perfect Live - 2 недели бесплатно",
//         subtitle: "Скидка 10%",

//         description:
//           "Perfect.live — ваш онлайн-ассистент для упрощения каждого аспекта жизни. Мы поможем: Спланировать путешествие от А до Я, Забронировать отель, авиабилеты и трансфер, Арендовать любой транспорт, Организовать досуг и развлечения, Заказать столик в лучших ресторанах, Подобрать идеальный подарок. Как начать? Зарегистрируйтесь с помощью телефона и почты, Заполните профиль, Выберите интересующие категории, Создайте свой первый запрос! Специальное предложение! Две недели бесплатного доступа к персональному консьерж-сервису по коду CHICPROMO! В подарок — три бесплатных запроса и дополнительная скидка на подписку!",

//         offerOne: "🎁 2 недели бесплатного доступа",
//         offerTwo: "🆓 3 бесплатных запроса",
//         offerThree: "🤝 10% скидка на мембершип",

//         imageFileName: "PerfectLive_concierge.JPG",
//         code: "CHIC25",
//         redirectUrl: "https://app.perfect.live/?referralCode=CHICPROMO",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Concierge", "Services", "Travel"],

//         websiteLink: "https://perfect.live",
//         vendorContact: "+447537157527",
//       },

//       {
//         id: "trustsearch-talent-consulting",
//         name: "Trust Search — Executive Search Company",
//         subtitle: "Скидка 10%",

//         description:
//           "Trust Search — семейная бутик-компания по поиску талантов. Надежный консультант для банков, корпораций, семейных офисов и частных клиентов в Великобритании, Швейцарии, Монако, ЦВЕ, а также на Ближнем Востоке и в Африке. Консультируем по привлечению и удержанию человеческого капитала.",
//         offerOne:
//           "💼 10% скидка на услуги по подбору и удержанию ключевых специалистов",
//         imageFileName: "trustsearch.jpeg",
//         code: "CHIC25",
//         redirectUrl:
//           "https://wa.me/447500900060?text=Здравствуйте%2C%20я%20участник%20Chic%2C%20хочу%20узнать%20подробнее%20об%20услугах%20с%20эксклюзивной%20скидкой%20для%20членов%20сообщества.",
//         location: ["All", "United Kingdom", "Worldwide"],
//         category: ["Services", "Executive Recruitment", "Consulting"],
//         websiteLink: "https://www.trustsearch.london",
//         vendorContact: "+447500900060",
//       },

//       {
//         id: "chateau-leperon-bordeaux",
//         name: "Château L’Eperon",
//         subtitle: "Скидки до 10%",

//         description:
//           "Винно-туристический проект в регионе Бордо, всего в 20 минутах от Сант-Эмильона. Две 5 ⭐️ виллы (на 6 или 10 человек) среди виноградников, дегустации авторских вин, пикники, прогулки на лошадях, частные и корпоративные мероприятия.",
//         offerOne: "🍇 Скидка 10% на визит и дегустации",
//         offerTwo:
//           "🍷 Скидка 10% на заказ вина (доставка оплачивается отдельно)",
//         offerThree: "🏡 Скидка 5% на аренду 5 ⭐️ вилл",

//         imageFileName: "chateau_leperon.jpeg",
//         code: "CHIC25",
//         redirectUrl:
//           "https://wa.me/33607602184?text=Здравствуйте%2C%20я%20участник%20Chic%2C%20хочу%20воспользоваться%20предложением%2C%20доступным%20для%20членов%20сообщества.",
//         location: ["France"],
//         category: ["Travel", "Entertainment", "Services"],

//         websiteLink: "https://www.chateau-leperon.com",
//         vendorContact: "+33607602184",
//       },

//       {
//         id: "zima-restaurant-nottinghill",
//         name: "ZIMA Restaurant",
//         subtitle: "Скидка 10%",
//         description: "Эксклюзивная скидка для участников сообщества Chic.",
//         offerOne: "🍽️ 10% скидка на ужин в ресторане ZIMA в Ноттинг-Хилле",
//         offerTwo:
//           "📍 Уточните детали при бронировании — только для участников Chic",
//         imageFileName: "zima_restaurant.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://sevn.ly/xoyg3n4E",
//         location: ["United Kingdom"],
//         category: ["Restaurants", "Entertainment"],
//         websiteLink: "https://zima.restaurant/zimanotting",
//         vendorContact: "+442045388866",
//       },
//       {
//         id: "zima-restaurant-soho",
//         name: "ZIMA Restaurant — Soho",
//         subtitle: "Скидка 10%",

//         description: "Эксклюзивная скидка для участников сообщества Chic.",
//         offerOne: "🍽️ 10% скидка на ужин в ресторане ZIMA в Сохо",
//         offerTwo:
//           "📍 Уточните детали при бронировании — только для участников Chic",
//         imageFileName: "zima_restaurant.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://sevn.ly/x76jkmXX",
//         location: ["United Kingdom"],
//         category: ["Restaurants", "Entertainment"],
//         websiteLink: "https://zima.restaurant/zimasoho",
//         vendorContact: "+442074949111",
//       },
//       {
//         id: "zima-home-delivery",
//         name: "ZIMA — Доставка на дом",
//         subtitle: "Скидка 25%",

//         description: "Эксклюзивная скидка для участников сообщества Chic.",
//         offerOne: "🛵 25% скидка на доставку блюд ZIMA на дом с кодом CHIC25",
//         offerTwo:
//           "🛒 Заказ через онлайн-платформу ZIMA — только для участников Chic",
//         imageFileName: "zima_restaurant.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://zimasw.slerp.com/order",
//         location: ["United Kingdom"],
//         category: ["Restaurants", "Delivery", "Food and Beverages"],
//         websiteLink: "https://zimasw.slerp.com/order",
//         vendorContact: "+442074949111",
//       },
//       {
//         id: "attilus-caviar-london",
//         name: "Attilus Caviar — Скидка на Royal Oscietra",
//         subtitle: "Скидка 10%",

//         description:
//           "Attilus Caviar – осетровая икра для гурманов от одного из ведущих европейских брэндов. Возможность доставки в тот же день по центру Лондона. Эксклюзивная скидка на Royal Oscietra Caviar для членов сообщества. Применяется автоматически при оформлении заказа онлайн.",
//         imageFileName: "attilus_logo.png",
//         code: "CHIC2025",
//         redirectUrl:
//           "https://www.attiluscaviar.co.uk/discount/CHIC2025?redirect=%2Fproducts%2Froyal-oscietra-caviar",
//         location: ["United Kingdom"],
//         category: ["Delivery", "Food and Beverages"],
//         websiteLink: "https://www.attiluscaviar.co.uk",
//         vendorContact: "+442077238009",
//       },

//       {
//         id: "pinna-dining",
//         name: "Ресторан Pinna",
//         subtitle: "Скидка 10 фунтов/бронирование",
//         description: "Подарок для участников Chic Loyalty.",
//         offerOne: "🍽️ Обед и ужин с понедельника по субботу",
//         offerTwo: "🥂 Игристое по прибытии",
//         imageFileName: "PINNA LOGO BLACK.png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/pinna_phone_reservation",
//         location: ["United Kingdom"],
//         category: ["Restaurants", "Entertainment"],
//         websiteLink: "https://www.pinnamayfair.com/",
//         vendorContact: "+447584574732",
//       },

//       {
//         id: "krokodilos-dining",
//         name: "Ресторан Krokodilos",
//         subtitle: "Скидка 10%",

//         description: "Специальное предложение для участников Chic Loyalty.",
//         offerOne: "🍽️ Обед с понедельника по пятницу: 10% скидка",
//         offerTwo:
//           "🥂 Понедельник – четверг с 17:00 до 19:00: игристое по прибытии",
//         imageFileName: "KROKODILOS.png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/krokodilos_phone_reservation",
//         location: ["United Kingdom"],
//         category: ["Restaurants", "Entertainment"],
//         websiteLink: "https://www.krokodilos.co.uk/",
//         vendorContact: "+447584574732",
//       },
//       {
//         id: "wild-nottinghill",
//         name: "Ресторан Wild — Notting Hill",
//         subtitle: "Скидка 10%",

//         description: "Эксклюзивная скидка для участников Chic Loyalty.",
//         offerOne: "🍽️ Обед с понедельника по пятницу: 10% скидка",
//         imageFileName: "WILD_NH.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/wildNH_phone_reservation",
//         location: ["United Kingdom"],
//         category: ["Restaurants", "Entertainment"],
//         websiteLink: "https://www.wildnottinghill.com/",
//         vendorContact: "+447584574732",
//       },
//       {
//         id: "belvedere-events",
//         name: "Ресторан Belvedere",
//         subtitle: "Скидка 10%",
//         description:
//           "Мероприятия — 10% скидка при полной аренде пространства или аренде верхнего этажа",
//         imageFileName: "Belvedere logo.png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/belvedere_phone_reservation",
//         location: ["United Kingdom"],
//         category: ["Restaurants", "Entertainment", "Events"],
//         websiteLink: "https://www.belvedererestaurant.co.uk/",
//         vendorContact: "+447584574732",
//       },
//       {
//         id: "azbuka-school",
//         name: "AZBUKA School",
//         subtitle: "Скидка 10%",

//         description:
//           "Скидка на первый год обучения в общеобразовательной билингвальной школе AZBUKA с русско-английской программой обучения — эксклюзивно для участников Chic.",
//         offerOne: "🎓 10 % скидка на первый учебный год по коду CHIC25",
//         imageFileName: "azbuka_school.jpg",
//         code: "CHIC25",
//         redirectUrl: "mailto:admin@azbukafoundation.org",
//         location: ["United Kingdom"],
//         category: ["Education"],
//         websiteLink: "https://www.azbukafoundation.org/?utm_source=chic",
//         vendorContact: "+442083922286",
//       },

//       {
//         id: "keepbeauty-wellness-bundle",
//         name: "Салон Keep Beauty",
//         subtitle: "Скидки до 15%",
//         description:
//           "Участникам Chic Loyalty доступны эксклюзивные скидки в уютной атмосфере Keep Beauty:",
//         offerOne: "💅 10% на маникюр",
//         offerTwo: "💇‍♀️ 15% на уход за волосами",
//         imageFileName: "keep_beauty_logo.JPG",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/keep-beauty",
//         location: ["United Kingdom"],
//         category: ["Wellness", "Beauty"],
//         websiteLink: "https://keepbeauty.co.uk/",
//         vendorContact: "+447411347960",
//       },
//       {
//         id: "zima-style-wellness-bundle",
//         name: "Салон ZIMA Style",
//         subtitle: "Скидки до 20%",
//         description:
//           "Участникам Chic Loyalty доступны специальные условия в салоне ZIMA STYLE в Holland Park:",
//         offerOne: "💇‍♀️ 10% на укладки — вечерние, свадебные и повседневные",
//         offerTwo: "💆‍♀️ 20% на уходы, включая «Счастье для волос»",
//         offerThree: "👁️ 10% на брови и ресницы — коррекция и окрашивание",
//         offerFour:
//           "🧖‍♀️ Парики: прокат от £400 в день со скидкой 10%, продажа со средней ценой £3500 и скидкой 5%",
//         imageFileName: "zima_style.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/zimastyle-salon",
//         location: ["United Kingdom"],
//         category: ["Wellness", "Beauty", "Services"],
//         websiteLink: "https://sergiizyma.co.uk/",
//         vendorContact: "+447881238229",
//       },
//       {
//         id: "albatross-healthcare",
//         name: "Albatross Healthcare — Personal Insurance Concierge",
//         description:
//           "Albatross Healthcare — независимый эксперт по международному медицинскому страхованию и страхования жизни. Участникам Chic Loyalty доступны:",
//         offerOne:
//           "🤝 ⁠Полное ведение страховых случаев с безлимитным количеством обращений",
//         offerTwo:
//           "📞 Прямой контакт только с руководителем компании (без посредников и junior staff)",
//         offerThree: "🔁 Аудит текущих полисов под ваши нужды",
//         offerFour: "👨‍💼 Контакты лучших врачей по всему миру",
//         offerFive: "‼️ Специальным ценовые предложения",
//         imageFileName: "alba_white.JPG",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/alba",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Health", "Insurance", "Services"],
//         websiteLink: "https://albatrosshealthcare.co.uk/",
//         vendorContact: "+442045772274",
//       },

//       {
//         id: "aqlo-accounting",
//         name: "AQLO Accounting & Law",
//         subtitle: "Скидки до 50%",

//         description:
//           "Профессиональные бухгалтерские и налоговые услуги для компаний и частных клиентов: от комплексного сопровождения бизнеса до индивидуальных консультаций и налоговой оптимизации.",
//         offerOne: "📊 50% скидка на налоговую консультацию",
//         offerTwo:
//           "💼 10% скидка на услуги после консультации (SA, годовая отчетность, корпоративный налог, бухгалтерия)",
//         imageFileName: "aqlo_logo.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/aqlo-accounting",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Finance", "Tax", "Services", "Legal"],
//         websiteLink: "https://aqlo.co.uk/",
//         vendorContact: "+447800767690",
//       },
//       {
//         id: "sterling-law",
//         name: "Sterling Law",
//         subtitle: "Скидка 15%",

//         description:
//           "Sterling Law — юридическая фирма с 15-летним опытом, входящая в рейтинг The Legal 500. Специализация: иммиграционное, корпоративное, трудовое, семейное и уголовное право. Обслуживаем частных и корпоративных клиентов. Многопрофильная русско- и украиноязычная юридическая поддержка в центре Лондона.",
//         offerOne: "⚖️ 15% скидка для участников Chic Loyalty",
//         imageFileName: "sterling_law_logo.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/sterling-law",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Legal", "Immigration", "Services"],
//         websiteLink: "https://sterling-law.co.uk/",
//         vendorContact: "+447935884144",
//       },

//       {
//         id: "ibsvp-services",
//         name: "IBSVP Concierge & Services",
//         subtitle: "Скидка 10%",

//         description:
//           "Российские документы, переводы, нотариальное сопровождение и премиальный туристический сервис в Лондоне.",
//         offerOne: "🛂 Загранпаспорт РФ + запись: £200 — 10 %",
//         offerTwo: "📑 Доверенность в посольстве РФ: £200 — 10 %",
//         offerThree: "📝 Перевод RU→EN — 10 %",
//         offerFour: "🇷🇺 Гражданство / выход — 10 %",
//         imageFileName: "ibsvp_logo.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/IBSVP",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Services", "Legal", "Immigration", "Travel", "Concierge"],
//         websiteLink: "https://ibsvp.co.uk/",
//         vendorContact: "+442079851234",
//       },
//       {
//         id: "beyond-residence-citizenship",
//         name: "BEYOND Residence & Citizenship",
//         subtitle: "Скидка 10%",
//         description:
//           "Паспорт и ПМЖ в 33 странах. Неординарные решения для частных клиентов и их семей.",
//         offerOne:
//           "🌍 10% скидка на услуги по получению ПМЖ и гражданства в 33 странах",

//         imageFileName: "beyond_logo.jpeg",
//         code: "CHIC25",
//         redirectUrl:
//           "https://wa.me/447341512626?text=Здравствуйте%2C%20я%20участник%20Chic%2C%20хочу%20воспользоваться%20скидкой%2010%%20на%20услуги%20BEYOND.",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Legal", "Immigration", "Services"],
//         websiteLink: "https://beyondimmigration.ru/",
//         vendorContact: "+447341512626",
//       },
//       {
//         id: "solvix-uk-relocation",
//         name: "Solvix UK Relocation",
//         subtitle: "Скидка 10%",
//         description: "Полное сопровождение переезда в Британию под ключ.",
//         offerOne: "🏠 10 % скидка на пакеты релокации в GB",
//         imageFileName: "solvix_logo.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/solvix-uk",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Services", "Immigration", "Real Estate", "Consulting"],
//         websiteLink: "https://www.solvix.co.uk/",
//         vendorContact: "+442079851222",
//       },
//       {
//         id: "az-real-estate",
//         name: "AZ Real Estate, скидка на услуги агенства",
//         subtitle: "Скидка 10%",
//         description:
//           "AZ Real Estate — агентство недвижимости с 13-летним опытом и офисом в центре Лондона. Помогаем частным клиентам купить, продать и инвестировать в недвижимость в Великобритании. Индивидуальный подход и экспертиза мирового уровня.",
//         offerOne: "🏠 Бесплатная консультация",
//         offerTwo: "📈 Скидка 10% на услуги AZ Real Estate",
//         imageFileName: "az_real_estate_logo.png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/az-real-estate",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Real Estate", "Finance", "Consulting"],
//         websiteLink: "https://www.azrealestate.uk/",
//         vendorContact: "+442038714074",
//       },

//       {
//         id: "visatogo",
//         name: "VisaToGo",
//         subtitle: "Скидка 10%",
//         description: "Визы в РФ, Шенген, США, Китай и др. страны.",
//         offerOne: "🛂 10 % скидка на любые визы",
//         imageFileName: "visatogo_logo.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/visa-to-go",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Travel", "Immigration", "Services"],
//         websiteLink: "https://visatogo.co.uk/",
//         vendorContact: "+442079851212",
//       },
//       {
//         id: "martins-travel",
//         name: "Martin's Travel",
//         subtitle: "Скидка 5%",
//         description: "Индивидуальные путешествия «под ключ» по всему миру.",
//         offerOne: "✈️ 5 % скидка на комплексные туры",
//         imageFileName: "martins_travel_logo.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/martins-travel",
//         location: ["Worldwide"],
//         category: ["Travel", "Concierge"],
//         websiteLink: "https://www.martins.travel/",
//         vendorContact: "+442079851245",
//       },

//       {
//         id: "pegasus-private",
//         name: "Pegasus Private Cars",
//         subtitle: "Скидка 10%",
//         description:
//           "Pegasus Private Cars — эксклюзивный сервис аренды премиум-автомобилей с личным водителем. Мы предлагаем комфорт, конфиденциальность и персонализированные решения для самых требовательных клиентов.",
//         offerOne: "👨🏼‍✈️ 10% скидка на услуги личного водителя",
//         offerTwo: "🧒 Сопровождение детей в школу или аэропорт",
//         offerThree:
//           "🐾 Транспортировка домашних питомцев по Великобритании и за её пределами",
//         offerFour: "🧳 Встречи в аэропорту и помощь с багажом",
//         offerFive: "✨ Индивидуальные услуги по запросу",
//         imageFileName: "pegasus_private_cars.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/pegasus-auto",
//         location: ["United Kingdom"],
//         category: ["Transport", "Travel", "Concierge"],
//         websiteLink: "https://www.instagram.com/p/DELOirlOViw/",
//         vendorContact: "+447728325988",
//       },
//       {
//         id: "soulmatcher-app-comingsoon",
//         name: "SoulMatcher",
//         subtitle: "Месяц бесплатной подписки",

//         description:
//           "SoulMatcher — премиальное приложение для серьёзных знакомств, созданное для профессионалов и предпринимателей, которые ценят психологическую совместимость и не хотят отношений с высоким риcком разрыва. Доступ получают только участники, прошедшие предварительный отбор. SoulMatcher — пространство, где создаются настоящие отношения.",
//         offerOne:
//           "🎁 Для сообщества Global Chic: используйте инвайт-код GCHIC при регистрации и получите 1 месяц бесплатной подписки",
//         offerTwo:
//           "📩 Всем участникам коммьюнити Глобал Шик регистрация доступна по приглашению через лист ожидания",

//         imageFileName: "SoulMatcher Logo (1).ai.jpg",
//         redirectUrl: "https://soulmatcher.app/",
//         location: ["Worldwide", "United Kingdom"],
//         category: ["Wellness", "Entertainment", "Services"],
//       },

//       {
//         id: "masterpiece-group",
//         name: "MASTERPIECE GROUP",
//         subtitle: "Скидка 10%",
//         description:
//           "это команда экспертов с 14-летним опытом, которая помогает предпринимателям и инвесторам обустроить жизнь и запустить бизнес в Объединённых Арабских Эмиратах. Мы сопровождаем вас на каждом этапе: от регистрации компании и получения ВНЖ — до покупки и управления недвижимостью, а также оптимизации налоговой нагрузки.",
//         offerOne:
//           "💼 10% скидка на бизнес-услуги в Дубае (регистрация компаний, ВНЖ, открытие счетов)",
//         offerTwo: "🏆 Бесплатная золотая виза при покупке недвижимости",
//         offerThree: "🏠 10% скидка на услуги по управлению вашей недвижимостью",
//         imageFileName: "masterpiece.png",
//         redirectUrl: "https://t.ly/masterpiece-group",
//         location: ["Worldwide", "United Arab Emirates"],
//         category: ["Services", "Consulting"],
//         websiteLink: "https://masterpiece.ae",
//         vendorContact: "+971505578931",
//       },
//       {
//         id: "masterpiece-concierge",
//         name: "MASTERPIECE CONCIERGE",
//         subtitle: "Скидка 10%",
//         description:
//           "Премиальный консьерж-сервис в Дубае 24/7. Мы берём на себя все организационные вопросы: трансферы, бронирования, клубная жизнь, личный ассистент, шопинг-сопровождение и любые запросы, доступные 24/7.",
//         offerOne: "🚗 10% скидка на транспортные услуги",
//         offerTwo: "💳 10% скидка на клубную карту MASTERPIECE",
//         imageFileName: "masterpiece.png",
//         redirectUrl: "https://t.ly/masterpiece-concierge",
//         location: ["Worldwide", "United Arab Emirates"],
//         category: [
//           "Concierge",
//           "Services",
//           "Finance",
//           "Immigration",
//           "Legal",
//           "Real Estate",
//           "Tax",
//           "Transport",
//           "Travel",
//         ],
//         websiteLink: "https://masterpiece.ae/services/concierge-services/",
//         vendorContact: "+971505578931",
//       },
//       {
//         id: "mango-language-school",
//         name: "Mango Language School — Языковая школа",
//         subtitle: "Скидка 15%",

//         description:
//           "🚀 С 1 ОКТЯБРЯ СТАРТУЕТ НОВЫЙ КУРС PROFESSIONAL ENGLISH для взрослых, которые хотят улучшить английский для карьеры. 🌍 Mango Language School — онлайн-школа иностранных языков с международными преподавателями, современными методиками и индивидуальным подходом. Также доступны программы по русскому, испанскому и другим языкам для детей и взрослых.",
//         offerOne: "🎁 Первый урок — бесплатно",
//         offerTwo: "💸 15% скидка на все занятия при записи через сообщество",
//         offerThree:
//           "👧🧑‍🎓 Для детей от 6 лет и взрослых, подготовка к экзаменам GCSE и A-Level",
//         offerFour:
//           "🌍 Русский, испанский и другие языки, включая программы для билингвов",
//         offerFive:
//           "🏢 Корпоративные программы для компаний + онлайн/выезд преподавателя",
//         imageFileName: "mango-school.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/mango-language-school",
//         location: ["United Kingdom", "Worldwide"],
//         category: ["Education", "Services"],
//         websiteLink: "https://www.mangoengl.com/ru",
//         vendorContact: "+44 7 4583 57899",
//         email: "Tina.nevin2020@gmail.com",
//         contactName: "Кристина Nevin",
//       },
//       {
//         id: "kartina-tv",
//         name: "Kartina.TV",
//         subtitle: "Пробная подписка без привязки карты",

//         description:
//           "Kartina.TV — 9 видеотек и 200+ каналов в любой точке мира.",
//         offerOne:
//           "🎁 Эксклюзивный бесплатный пробный период для участников Chic — без привязки банковской карты ",
//         offerTwo: "📱 Удобное приложение для iOS и Android",
//         offerThree: "🔄 Одновременный просмотр на трёх устройствах",
//         offerFour: "🕑 Круглосуточная служба технической поддержки",
//         imageFileName: "kartina.png",
//         redirectUrl: "https://t.ly/kartina-tv",
//         location: ["All", "United Kingdom", "Worldwide"],
//         category: ["Entertainment", "Services"],
//         websiteLink: "https://www.kartina.tv",
//         vendorContact: "0 800 090 31 33",
//         email: "i.kryvonos@kartina.tv",
//         contactName: "Ivan",
//       },
//       {
//         id: "boss-ii-organic-wine-olive-oil",
//         name: "BOSS II Organic Wine&Olive Oil",
//         subtitle: "Скидки до 15%",

//         description:
//           "BOSS II — семейный бизнес по производству органического вина и оливкового масла в Тоскане. Первая винтажная коллекция 2022 года уже отмечена экспертами. Доставка до двери в Италии, Европе и Лондоне по запросу.",
//         offerOne: "🍇 10% скидка для участников Chic в Италии",
//         imageFileName: "SelivanovaWines.jpg",
//         redirectUrl: "https://t.ly/SelivanovaWines",
//         location: ["Italy", "Worldwide"],
//         category: ["Food and Beverages", "Wine"],
//         vendorContact: "+447795968314",
//         email: "olga.selivanova@yahoo.co.uk",
//         contactName: "Ольга Селиванова",
//       },
//       {
//         id: "eli-gervits-law",
//         name: 'Адвокатская коллегия "Эли Гервиц"',
//         subtitle: "Скидка 10%",

//         description:
//           "Крупнейшая в Израиле русскоязычная адвокатская коллегия. Департаменты: израильский, международный, российский, финансовый.",
//         offerOne: "⚖️ Персональное сопровождение дел",
//         offerTwo: "🌍 Израильское, международное и российское право",
//         offerThree: "💼 Финансовый департамент и комплексные решения",
//         imageFileName: "Daniel_Rapoport.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://aliya.zakon.co.il/#contacts",
//         location: ["Israel", "Worldwide"],
//         category: ["Legal", "Immigration", "Finance", "Services"],
//         websiteLink: "https://outrussian.zakon.co.il/",
//         vendorContact: "zakon@zakon.co.il",
//       },
//       {
//         id: "marco-barberi-dentist",
//         name: "Studio Dentistico Marco Barberi",
//         subtitle: "Скидка 5% + бесплатная гигиеническая чистка",

//         description:
//           "Доктор Марко Барбери — стоматолог в центре Форте-дей-Марми (Тоскана, Италия). Практика с 1994 года (31 год опыта). Полный спектр стоматологических услуг: хирургия (импланты, костная реконструкция), эстетика (виниры, пломбы), протезирование (коронки и большие реконструкции), ортодонтия (традиционная и Invisalign), пародонтология. Философия работы — максимальное качество, доброжелательность и доступность.",

//         offerOne: "🎁 5% скидка на все лечения",
//         offerTwo:
//           "🦷 Бесплатная гигиеническая чистка при записи через сообщество",

//         imageFileName: "Marco_Barberi.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://www.marcobarberi.it",

//         location: ["Italy"],
//         category: ["Health", "Wellness", "Services"],

//         websiteLink: "https://www.marcobarberi.it",
//         vendorContact: "+393478151020",
//         email: "blu5marco@gmail.com",
//         contactName: "Dr. Marco Barberi",
//       },
//       {
//         id: "ls-legal-solicitors",
//         name: "LS Legal Solicitors",
//         subtitle: "Скидка 10%",
//         description:
//           "LS Legal Solicitors — многопрофильная юридическая фирма в Великобритании. Мы работаем с бизнесом и частными клиентами, предоставляя услуги в сфере иммиграции и гражданства, гражданских, семейных, трудовых и жилищных дел. Также оказываем поддержку при переезде в Великобританию, предоставляем коммерческие и бухгалтерские услуги, юридическое сопровождение бизнеса, легализацию и переводы. Отличаемся индивидуальным подходом и высоким уровнем сервиса.",

//         offerOne:
//           "⚖️ Иммиграция, гражданство и релокация в Великобританию и ОАЭ",
//         offerTwo: "📑 Гражданские, семейные, трудовые и жилищные дела",
//         offerThree:
//           "💼 Коммерческие услуги, договорное право и бизнес-поддержка",
//         offerFour: "📊 Бухгалтерские и налоговые консультации",
//         offerFive: "🌍 Переводы, легализация и сертификация документов",

//         imageFileName: "ls_legal.png",
//         code: "CHIC25",
//         redirectUrl: "https://www.lslegaluk.com/contact-us",
//         location: ["United Kingdom", "Worldwide"],
//         category: ["Legal", "Immigration", "Services", "Finance", "Consulting"],
//         websiteLink: "https://www.lslegaluk.com/",
//         vendorContact: "+447535959450",
//         email: "info@lslegaluk.com",
//         contactName: "Liliya Scott",
//       },
//       {
//         id: "yt-partners-yachting",
//         name: "YT Partners",
//         subtitle: "Дополнительные услуги клиенту",

//         description:
//           "YT Partners — профессионалы в сфере аренды, управления и продаж яхт. Приглашаем вас на Monaco Yacht Show, который пройдет 24–27 сентября в Порт Эркюль, Монако. Для участников Chic доступны приглашения и персональные визиты на лучшие суперъяхты.",

//         offerOne:
//           "🛥️ Для арендаторов: индивидуальный подбор яхт под ваши требования",
//         offerTwo:
//           "🔑 Эксклюзивный доступ к private listing + комплимент Dom Perignon при посадке",
//         offerThree: "🤝 Консьерж-сервис 24/7 и полное сопровождение круиза",
//         offerFour:
//           "⚓ Для владельцев: профессиональное управление яхтами до 95 метров",

//         imageFileName: "yt_partners_logo.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/yt.partners",

//         location: ["Worldwide", "United Kingdom", "Monaco", "France"],
//         category: ["Luxury", "Travel", "Yachting", "Concierge"],

//         websiteLink: "https://yt.partners/",
//         vendorContact: "+447500173119",
//         email: "dl@yt.partners",
//         contactName: "Даша Лялина",
//       },
//       {
//         id: "dseesion-interiors",
//         name: "Dseesion Interiors",
//         subtitle: "Скидка £3,000 + особые условия",

//         description:
//           "Интерьерное бюро Dseesion Interiors — более 20 лет создаёт и реализует под ключ премиальные проекты жилой и коммерческой недвижимости по всему миру. Победители международных конкурсов в сфере дизайна. Креативная команда с большим практическим опытом, умением доводить проекты до конца в срок и в рамках бюджета.",
//         offerOne: "🎁 £3,000 скидка при заключении договора на дизайн-проект",
//         offerTwo:
//           "🛋️ Особые условия на закупки мебели и предметов декора при реализации проекта",
//         imageFileName: "dseesion_logo.png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/dseesion-interiors",
//         location: ["Worldwide", "United Kingdom"],
//         category: [
//           "Design",
//           "Architecture",
//           "Luxury",
//           "Services",
//           "Real Estate",
//         ],
//         websiteLink: "https://dseesion.com",
//         vendorContact: "+447506863221",
//         email: "valeria.senkina@dseesion.com",
//         contactName: "Сенькина Валерия",
//       },

//       {
//         id: "your-place-with-grace",
//         name: "Your Place with Grace",
//         subtitle: "Скидка до 15%",
//         description:
//           "Your Place with Grace — премиальные проекты под ключ: от ремонта и мебели на заказ до обслуживания недвижимости. Качество, сроки и комфорт без компромиссов.",
//         offerOne: "🏗️ Строительство и ремонт — скидка до 10% на работы",
//         offerTwo: "🛋️ Мебель на заказ — скидка 10–15%",
//         offerThree: "⚡ Блиц-ремонты во время отпуска",
//         offerFour: "🧰 Обслуживание недвижимости и сопровождение строительства",
//         imageFileName: "your-place-with-grace.png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/your-place-with-grace",
//         location: ["United Kingdom"],
//         category: ["Services", "Construction", "Real Estate", "Design"],
//         websiteLink: "https://www.instagram.com/your.place.with.grace/",
//         vendorContact: "+447985957305",
//         email: "irina@yourplacewithgrace.co.uk",
//         contactName: "Irina Filatova",
//         discountTerms:
//           "Строительство и ремонт — скидка до 10% на работы; мебель — 10–15%.",
//       },
//       {
//         id: "lawsentis-immigration",
//         name: "LawSentis LTD",
//         subtitle: "Скидки до 20%",
//         description:
//           "LawSentis LTD — иммиграционные адвокаты (IAA Level 3). Помогаем с визами, гражданством, апелляциями, бизнес- и семейными кейсами, а также с релокацией и смежными вопросами.",
//         offerOne:
//           "✅ Pre-Settled, Settled, ILR, Натурализация и British Citizenship",
//         offerTwo:
//           "⚖️ Беженство, права человека и апелляции (lodging, skeleton, слушания)",
//         offerThree:
//           "🌍 Global Talent и бизнес-визы (Innovator Founder), подготовка бизнес-планов",
//         offerFour: "👨‍👩‍👧 Семейные визы: жених/невеста, супруги, родители",
//         offerFive:
//           "🇪🇸 Релокация в Испанию и Португалию; 📊 бухгалтерия: годовые отчёты и возврат налогов",
//         imageFileName: "law-sentis.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/law-sentis",
//         location: ["United Kingdom", "Spain", "Portugal", "Worldwide"],
//         category: ["Legal", "Immigration", "Business", "Services"],
//         websiteLink: "https://lawsentis.com/",
//         vendorContact: "+447733648414",
//         contactName: "LawSentis Team",
//       },
//       {
//         id: "showroom-studio-design-exclusiv",
//         name: "SHOWROOM — Studio Design Exclusiv",
//         subtitle: "Специальные условия для участников Chic",
//         description:
//           "Реализация интерьерных проектов - разработка дизайна, подбор и комплектация, авторский надзор. Дизайн-проекты собственной командой и мировыми дизайнерами, подбор и комплектация отделочных материалов, освещения, мебели, кухонь, гардеробных и текстиля. Партнёрство с ведущими итальянскими и международными брендами (Poliform, Minotti, Flexform, Antonio Lupi, Flos, Hermes Home и др.).",
//         offerOne: "🎁 Специальные условия при комплексной реализации проектов",
//         offerTwo:
//           "🛋️ Специальные цены на продукцию премиальных брендов для дома",
//         offerThree:
//           "✨ Мебель, освещение, текстиль от ведущих мировых производителей",
//         imageFileName: "studio_design_exclusiv1.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/studio-design-exclusiv",
//         location: ["United Kingdom", "Worldwide"],
//         category: ["Design", "Interiors", "Luxury", "Services"],
//         websiteLink: "www.studiodesign.md",
//         vendorContact: "+373 79 585 777",
//         email: "office@studiodesign.md",
//         contactName: "Alex Naval",
//         discountTerms:
//           "Специальные условия при реализации проектов + специальные цены на продукцию брендов",
//       },
//       {
//         id: "uk-study-centre",
//         name: "UK Study Centre",
//         subtitle: "Скидка 10%",
//         description:
//           "UK Study Centre — ваш консультант по британскому образованию с 20-летним опытом. Топовые британские тьюторы по всем предметам. Бесплатные консультации по летним и языковым школам для участников сообщества. Скидка 10% на пакеты по поступлению в школы и университеты Великобритании и других стран.",
//         offerOne: "🎁 Бесплатные консультации по летним и языковым школам",
//         offerTwo:
//           "🎓 10% скидка на пакеты по поступлению в школы и университеты",
//         offerThree: "📚 Поддержка лучших британских тьюторов по всем предметам",
//         imageFileName: "uk_study_centre_logo.png",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/uk-study-centre",
//         location: ["United Kingdom", "Worldwide"],
//         category: ["Education", "Services"],
//         websiteLink: "https://www.ukstudycentre.com/",
//         vendorContact: "+447970293673",
//         email: "alex@ukstudycentre.com",
//         contactName: "Alex Nanian",
//         discountTerms:
//           "10% клиенту + 10% программе на пакеты по поступлению в школы/университеты",
//       },
//       {
//         id: "vdl-constructions-dubai",
//         name: "VDL Constructions — Строительство и дизайн в Дубае",
//         subtitle: "Специальные условия для участников Chic",
//         description:
//           "🏗️ VDL Constructions — дизайнерские решения, строительство и реновация премиум-класса в Дубае. Команда архитекторов, инженеров и строителей предлагает эксклюзивные проекты под ключ с использованием премиальных материалов и инновационных технологий. При заключении договора на строительство/реновацию:",
//         offerOne: "📐 Эскизный проект — бесплатно",
//         offerTwo: "📄 5% скидка на проектную документацию",
//         offerThree:
//           "👷‍♂️ Авторский надзор бесплатно при площади проекта от 600 м²",
//         imageFileName: "vdl_constructions.jpeg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/VDL_construction",
//         location: ["UAE", "Dubai"],
//         category: [
//           "Construction",
//           "Design",
//           "Luxury",
//           "Real Estate",
//           "Services",
//         ],
//         websiteLink: "https://vdlconstructions.com",
//         vendorContact: "+971508240177",
//         vendorContactAdditional: "+971547822211",
//         email: "info@vdlconstructions.com",
//         contactName: "VDL Constructions Team",
//         discountTerms:
//           "Эскизный проект бесплатно, скидка 5% на проектную документацию, авторский надзор бесплатно при проекте от 600 м².",
//       },
//       {
//         id: "shatro-construction",
//         name: "SHATRO",
//         subtitle: "Скидка 10%",
//         description:
//           "SHATRO — строительная компания, создающая современные жилые объекты, коммерческие пространства и офисы под ключ. Мы обеспечиваем архитектурную точность, выверенные решения и безупречное качество исполнения. Проектирование, строительство, авторский дизайн, подбор материалов, мебели и декора — полный цикл под одной командой",
//         offerOne:
//           "🏗️ Комплексные строительные и инвестиционные проекты под ключ",
//         offerTwo: "🎨 Дизайн и подбор отделочных материалов, мебели и декора",
//         offerThree: "🏡 Реализация жилых и коммерческих объектов",
//         imageFileName: "shatro_logo.jpg",
//         code: "CHIC25",
//         redirectUrl: "https://t.ly/shatro-construction",
//         location: ["Cyprus", "Worldwide", "United Kingdom"],
//         category: ["Construction", "Design", "Real Estate", "Services"],
//         websiteLink: "https://shatro.com/",
//         vendorContact: "+35795999595",
//         email: "assistant@shatro.com",
//         contactName: "Лариса",
//         discountTerms:
//           "10% клиенту + 10% программе при заключении договора на услуги.",
//       },
//     ]);
//   }

//   const response = await fetch("/api/loyalty/offers");
//   if (!response.ok) throw new Error("API error");
//   return await response.json();
// }
